import { reportCategories, type ReportCategory } from "@/lib/report-catalog"
import type { ReportHubCategory } from "@/lib/report-hub-access"

const VALID_HUBS = new Set<string>([...reportCategories.map((c) => c.id), "customers", "suppliers"])

export function parseReportsCategory(value: string | null | undefined): ReportHubCategory | null {
  if (!value) return null
  return VALID_HUBS.has(value) ? (value as ReportHubCategory) : null
}

/** Hub home, or catalog list for a category (`?category=sales`). */
export function reportsHubHref(category?: ReportHubCategory | null): string {
  if (!category) return "/dashboard/reports"
  return `/dashboard/reports?category=${category}`
}

/** Infer catalog category from a report page path so Close returns to the right list. */
export function categoryFromReportPath(pathname: string): ReportCategory | null {
  if (pathname.includes("/reports/pos/")) return "pos"
  if (pathname.includes("/reports/sales/")) return "sales"
  if (pathname.includes("/reports/purchase/")) return "purchase"

  const viewMatch = pathname.match(/\/reports\/view\/([^/]+)/)
  if (!viewMatch) return null
  const seg = viewMatch[1]
  if (seg === "stock") return "stock"
  if (seg === "sales") return "sales"
  if (seg === "purchase") return "purchase"
  if (
    [
      "summary-income",
      "daily-sales",
      "staff-sales",
      "groups-sales",
      "sales-analysis",
    ].includes(seg)
  ) {
    return "pos"
  }
  return null
}
